<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Acompanhamentos</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingAcompanhamentos"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                       {
                          key: 'protocolo',
                          label: $t('Detalhes'),
                        },
                        {
                          key: 'data_ingresso',
                          label: $t('Período'),
                        },
                        {
                          key: 'data_avaliacao',
                          label: $t('Avaliação'),
                        },
          ]"
              :items="AcompanhamentosList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Serviço:
              <b>{{ data.item.servico }}</b>
              <br/>
              Protocolo:
              <b>{{ data.item.protocolo }}</b>
              <br/>
              Técnico:
              <b>{{
                  data.item.responsavel
                      ? data.item.responsavel.name
                      : ""
                }}</b> - <span> {{ data.item.responsavel.tecnico.profissao ?? 'Não informado' }} </span>
            </template>
            <template v-slot:cell(data_ingresso)="data">
              {{ data.item.dataIngresso }}
              à {{ data.item.dataFinal }}
            </template>
            <template v-slot:cell(data_avaliacao)="data">
              {{ data.item.dataAvaliacao }}
            </template>


            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Atendimentos",
  props: ['familia'],
  data() {
    return {
      AcompanhamentosList: [],
      loadingAcompanhamentos: true,
    }
  },
  mounted() {
    this.getAcompanhamentos();
  },
  methods: {
    getAcompanhamentos() {

      this.loadingAcompanhamentos = true;
      axios
          .get(`api/dashboard/print/usuarios/acompanhamentos/${this.familia}`)
          .then((response) => {
            this.AcompanhamentosList = response.data.data;
            this.loadingAcompanhamentos = false;
          })
          .catch(() => {
            this.loadingAcompanhamentos = false;
          });
    },

  },
}
</script>

<style scoped>

</style>